import { Button, Form, Input } from 'antd';
import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminContext } from '../../../contexts/adminContext/adminContext';
import './Login.scss';
import translations from '../../../hooks/translation/translations.json';
import { checkLoginApi, loginApi } from '../../../../services/login/Login.api';
import AdminOtpVerifyModal from '../../modals/adminOtpVerifyModal/AdminOtpVerifyModal';

function Login() {
  const adminContext = useContext(AdminContext);
  const navigate = useNavigate();
  const [errors, setErrors] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [verifyModal, setVerifyModal] = useState({
    show: false,
  });

  const handleFinish = async (values) => {
    try {
      setIsLoading(true);
      const response = await loginApi(values);
      setIsLoading(false);
      if (response.data?.status === 'success') {
        setErrors(null);
        setVerifyModal({
          show: true,
          data: values,
        });
      }
    } catch (error) {
      setErrors(error?.response.data?.errors);
      setIsLoading(false);
    }
  };

  const checkLogin = async () => {
    try {
      if (localStorage.getItem('adminAccessToken')) {
        const response = await checkLoginApi(
          JSON?.parse(localStorage.getItem('adminAccessToken')),
        );
        if (response?.data?.status === 'success') {
          adminContext.setUser(response?.data?.user, response?.data?.token);
          navigate('/admin/');
        } else {
          adminContext?.resetUser();
          navigate('/admin/login');
        }
      }
    } catch (e) {
      adminContext?.resetUser();
      navigate('/admin/login');
    }
  };

  useEffect(() => {
    checkLogin();
  }, []);

  return (
    <div className="login-page">
      <Form
        layout="vertical"
        className={`login ${errors && 'error'}`}
        onFinish={handleFinish}
      >
        <Form.Item
          label={translations.ka.username}
          name="username"
          validateStatus={errors?.username && 'error'}
          help={errors?.username}
          rules={[
            {
              required: true,
              message: translations.ka.input_necessary,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={translations.ka.password}
          name="password"
          validateStatus={errors?.password && 'error'}
          help={errors?.password}
          rules={[
            {
              required: true,
              message: translations.ka.input_necessary,
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {translations.ka.submit}
          </Button>
        </Form.Item>
      </Form>
      <AdminOtpVerifyModal verifyModal={verifyModal} setVerifyModal={setVerifyModal} />
    </div>
  );
}

export default Login;
